module.exports = __webpack_public_path__ + "static/img/B (20).1f58b2ee.png";